<script>
	import Button from './Button.svelte';
	let className = '';
	export { className as class };
	export let width;
	export let height;
	export let fontSize;
	export let text;
	export let disabled = true;
	export let onClick = () => {};
	export let onMouseDown = () => {};
</script>

<div class="wrapperPrimary">
	<Button
		class="primary-btn {className}"
		{width}
		{height}
		{fontSize}
		{disabled}
		{onClick}
		{onMouseDown}
	>
		<span class="primary-btnText">
			{text}
		</span>
	</Button>
</div>

<style>
	.wrapperPrimary {
		width: fit-content;
		height: fit-content;
		border-radius: 7px;
		box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.15);
	}
	.wrapperPrimary :global(.primary-btn) {
		width: var(--width);
		height: var(--height);
		cursor: pointer;
		background: linear-gradient(45deg, var(--base-l-25) 50%, var(--base) 50%);
		border: 2px solid #ffffff;
		border-radius: 7px;
		margin: 0;
		padding: 0;
		display: flex;
		justify-content: center;
		align-items: center;
		box-shadow: 0px -4px 0px var(--base-d-60) inset;
		padding: 4px;
	}
	.primary-btnText {
		font-family: Pally;
		font-style: normal;
		font-weight: bold;
		font-size: var(--fontSize);
		line-height: var(--lineHeight);
		text-align: center;
		letter-spacing: -0.025em;
		color: #ffffff;
		text-shadow: 0px 1px 0px rgba(0, 0, 0, 0.15);
	}
	.primary-btnText {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
</style>
